import React from "react";
import CustomButton from "../ui/Button";
import { useTranslation } from "react-i18next";


const Cards = () => {
  const { t,i18n } = useTranslation("research"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian


  return (
    <div className="bg-black text-white container-class px-2.5 md:px-20 lg:px-[100px]">
      {/* First Card Section */}
      <div className="relative flex flex-col md:flex-row items-center gap-12">
        {/* Left Section with Card */}
        <div className="w-full md:w-1/2 h-[581px] relative">
          <div className="rounded-xl overflow-hidden shadow-lg h-full">
            <img
              src="/assets/r&d.png"
              alt="Safety Work Environment"
              className="w-full h-full object-cover transition-transform duration-1000 ease-in-out transform hover:scale-125"
            />
          </div>
        </div>

        {/* Right Section with Text */}
        <div className="w-full md:w-1/2 flex flex-col justify-center gap-6">
          <div className="title-small gradient-text font-semibold py-2 px-4 rounded-full mb-4 border border-color w-fit">
            {t("safety_first_title")}
          </div>
          <h2 className="web-heading-card-4 text-color-2 mb-4">
            {t("research_mission_title")}
          </h2>
          <p className="body-large text-color mb-4">
            {t("research_mission_description")}
          </p>
          <CustomButton className="w-fit mt-6">
            {t("research_explore_safety_solutions")}
          </CustomButton>
        </div>
      </div>

      {/* Second Card Section */}
      <div className="relative flex flex-col md:flex-row items-center gap-12 mt-32">
        {/* Right Section with Text */}
        <div className="w-full md:w-1/2 flex flex-col justify-center gap-6">
          <div className="title-small gradient-text font-semibold py-2 px-4 rounded-full mb-4 border border-color w-fit">
            {t("research_boost_workforce_efficiency")}
          </div>
          <h2 className="web-heading-card-4 text-color-2 mb-4">{t("research_approach_title")}</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex-1">
              <h3 className="title-medium-2 text-color-2 mb-2">
                {t("research_approach_collaborative_innovation")}
              </h3>
              <p className="body-medium-2 text-color">
               {t("partnering_with_institutions")}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="title-medium-2 text-color-2 mb-2">
                {t("research_approach_customer_centric_design")}
              </h3>
              <p className="body-medium-2 text-color">
              {t("actively_engaging_clients")}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="title-medium-2 text-color-2 mb-2">
                {t("research_approach_continuous_improvement")}
              </h3>
              <p className="body-medium-2 text-color">
                {t("conducting_regular_field_tests")}
              </p>
            </div>
          </div>
        </div>

        {/* Left Section with Card */}
        <div className="w-full md:w-1/2 h-[581px] relative">
          <div className="rounded-xl overflow-hidden shadow-lg h-full">
            <img
              src="/assets/empower.png"
              alt="Safety Work Environment"
              className="w-full h-full object-cover transition-transform duration-1000 ease-in-out transform hover:scale-125"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-center flex-col gap-4 items-center text-center py-[64px] px-2.5 ">
        <div className="max-w-[551px]">

        <h1 className={`text-[48px] font-normal leading-[52px] ${isRussian ? 'lang-ru-web-heading-font' : ''} `}>
          {t("future_of_mining_innovation")}
        </h1>
        </div>
        <div className="max-w-[720px]">

        <p className="text-[18px] font-light leading-5 text-[#F0F0F0B2]">
        {t("rnd_team_exploring_technologies")}
        </p>
        </div>
        <div className="flex flex-col md:flex-row justify-start items-start gap-8">
          <ul className="list-disc pl-5 text-[#E6E9EA4D] text-[36px] font-normal leading-10 space-y-3">
            <li className="text-left">{t("trusted_by_industry_leaders")}</li>
            <li className="text-left">{t("proven_safety_solutions")}</li>
            <li className="text-left">{t("efficiency_and_innovation")}</li>
          </ul>
          <ul className="list-disc pl-5 text-[#E6E9EA4D] text-[36px] font-normal leading-10 space-y-3">
            <li className="text-left">{t("enhanced_productivity")}</li>
            <li className="text-left">{t("real_time_insights")} </li>
            <li className="text-left">{t("sustainability_focus")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Cards;
